import { Injectable } from '@angular/core';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';

import { AppInfo } from '../../appsInfo/app-info';

@Injectable()
export class AppInfoService {

  constructor(protected requestService: RequestService, protected auth: Auth) { }

  get(): Promise<AppInfo[]> {
    return this.requestService.makeRequest({
      urlKey: 'appsInfo'
    })
      .then((response: any) => response.json() as AppInfo);
  };

  create(newApp:AppInfo): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'appsInfo',
      method: 'post',
      body: JSON.stringify(newApp)
    });
  }

  update(app: AppInfo): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'appInfo',
      urlParams: {
        id: app.id
      },
      method: 'put',
      body: JSON.stringify(app)
    });
  }

  delete(app:AppInfo): Promise<void> {
    return this.requestService.makeRequest({
      urlKey: 'appInfo',
      urlParams: {
        id: app.id
      },
      method: 'delete'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/appInfo/app-info.service.ts